import React from 'react';
import classNames from 'classnames';

// Styles
import './styles.scss';

interface Props {
    children: string | React.ReactElement | React.ReactNode;
    warning?: boolean;
    positive?: boolean;
    negative?: boolean;
}

const SemiBold = ({
    children,
    warning,
    positive,
    negative
}: Props): React.ReactElement => (
    <span
        className={classNames('semi-bold', {
            warning,
            positive,
            negative
        })}
    >
        {children}
    </span>
);

export default SemiBold;
